<template>
    <div class="highlightsNextButton">
        <div class="flex flex--center flex--spaceBetween">
            <p>{{ getNextChartTitle }}</p>
            <button
                class="highlightsNextButton__circle flex--shrink0"
                :class="{ 'disabled': isDisabled }"
                aria-label="next chart"
                :disabled="isDisabled"
                :data-gtm="`xmo__highlightsChart--${ getNextChartTitle }`"
                type="button"
                @click="setCurrentChart">
                <svg
                    class="highlightsNextButton__circle--svgIcon"
                    height="18"
                    width="18"
                    aria-hidden="true">
                    <use xlink:href="#iconChevronRightBold" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            sectionChartData: { type: Array, required: true },
            isDisabled: { type: Boolean, default: false },
        },
        data() {
            return {
                currentIndex: 1,
            };
        },
        computed: {
            getLastChart() {
                if (this.currentIndex === 0) {
                    return this.currentIndex + 1;
                }

                return this.currentIndex - 1;
            },
            isMinimumContent() {
                return this.sectionChartData?.length === 1;
            },
            getNextChartTitle() {
                if (this.isMinimumContent) {
                    return this.sectionChartData[0].chartData.title;
                }

                return this.sectionChartData[this.currentIndex].chartData.title;
            },
            getCurrentChartData() {
                if (this.isMinimumContent) {
                    return this.sectionChartData[0];
                }

                return this.sectionChartData[this.getLastChart];
            },
        },
        methods: {
            setCurrentChart() {
                if (this.currentIndex === this.sectionChartData?.length - 1) {
                    this.currentIndex = 0;
                    this.$emit('set-chart-selection', this.getCurrentChartData);

                    return;
                }
                this.currentIndex ++;
                this.$emit('set-chart-selection', this.getCurrentChartData);
            },
        },
    };
</script>
